module.exports = __webpack_public_path__ + "static/media/design-img.5be1c268.png";